import { ApiReportReportTypeChoices, ReportSectionsType } from "@api/graphql/types-and-hooks";
import { useIsReportCompleted, useIsReviewPage } from "@components/ReportField/capabilities/flags";
import { APPENDIX_PAGE_LOCATION } from "@components/ReportField/consts";
import { useReport } from "@providers/ReportProvider";

// Whether "Return to <previous location>" shows for a section already on the
// appendix. Only Diagnosis Evaluation (step viewer) sections carry a
// `previousPageLocation` to return to.
export const useCanReturnSectionFromAppendix = (section: ReportSectionsType): boolean => {
  const { report, viewMode } = useReport();
  const isReviewPage = useIsReviewPage();
  const isCompleted = useIsReportCompleted();

  if (isReviewPage || isCompleted) return false;
  if (report.reportType !== ApiReportReportTypeChoices.DiagnosisEvaluation || viewMode !== "step") return false;

  return section.pageLocation === APPENDIX_PAGE_LOCATION && !!section.previousPageLocation;
};
